const {
  getAudioWorkerRootHost,
} = require('../../server/scripts/utils.js')();

export const delay = (ms = 1000) => new Promise(resolve => setTimeout(resolve, ms));

export const getExactAudioWorkerRootHost = () => {
  const key = window.location.href.includes('localhost') ? 'local' : '';
  return getAudioWorkerRootHost(key);
}

